import storeModule from '../../../store-module'
import { defineStore } from 'pinia'

const url = 'active-offers/dashboard/broker-classification'

export default defineStore(
  'active-offers-broker-classification',
  storeModule.createStoreModule('active-offers-broker-classification', {
    fetchListURL: url,
    fetchFiltersURL: `${url}/filters`
  })
)
